import type { JSX } from 'preact';
import { useEffect } from 'preact/hooks';
import type { UseChat } from '../hooks/useChat';
import { Composer } from './Composer';
import { MessageList } from './MessageList';

interface ChatPanelProps {
  chat: UseChat;
  onClose: () => void;
  apiBaseUrl: string;
}

export function ChatPanel({ chat, onClose, apiBaseUrl }: ChatPanelProps): JSX.Element {
  // Escape closes the panel from anywhere within it.
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <section class="sa-panel" role="dialog" aria-label="مساعد مكتبة صوفيا">
      <header class="sa-header">
        <div>
          <h2 class="sa-title">مكتبة صوفيا</h2>
          <p class="sa-disclosure">مساعد آلي — قد يخطئ أحياناً. لا تشارك بيانات حساسة.</p>
        </div>
        <button type="button" class="sa-close" onClick={onClose} aria-label="إغلاق">
          ×
        </button>
      </header>

      <MessageList
        messages={chat.messages}
        onSend={chat.send}
        onRetry={chat.retry}
        apiBaseUrl={apiBaseUrl}
      />
      <Composer busy={chat.busy} onSend={chat.send} />
    </section>
  );
}
